import { z } from 'zod';
/**
 * Nhắc người trong tài liệu — APM-CD2-f, docs/plan-chilldoc-v2.md §6.
 *
 * Tệp đi presigned PUT (luật #3) nên server không đọc nội dung tài liệu: **sau khi Lưu thành
 * công**, trình duyệt gửi danh sách người **mới** được nhắc (so với bản lưu trước) tới
 * `POST me/files/:fileId/mentions` (tài liệu cá nhân) hoặc
 * `POST projects/:projectId/documents/:documentId/mentions` (tài liệu dự án).
 */
/** Trần người nhắc một lượt Lưu. */
export const MAX_DOCUMENT_MENTIONS = 50;
/** Trần đoạn trích quanh chỗ nhắc — câu trong thông báo, không phải nội dung tài liệu. */
export const DOCUMENT_MENTION_EXCERPT_MAX = 200;
export const DocumentMentionInput = z.object({
    userIds: z.array(z.uuid()).min(1).max(MAX_DOCUMENT_MENTIONS),
    excerpt: z.string().trim().max(DOCUMENT_MENTION_EXCERPT_MAX).default(''),
});
/**
 * Kết cục từng người. Ba danh sách rời nhau; người gọi tự nhắc mình thì không nằm ở đâu cả.
 *
 * - `notified` — đã gửi thông báo `document.mentioned`.
 * - `notShared` — **không** xem được tài liệu (chưa được chia sẻ / không phải thành viên dự án
 *   có `document:read`): không gửi gì, web hỏi "Chia sẻ cho họ?".
 * - `throttled` — xem được nhưng đã nhận thông báo về đúng tài liệu này trong 10 phút qua.
 */
export const DocumentMentionResult = z.object({
    notified: z.array(z.uuid()),
    notShared: z.array(z.uuid()),
    throttled: z.array(z.uuid()),
});
//# sourceMappingURL=document-mention.js.map